import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import isEmpty from 'lodash/isEmpty'
import { HeaderLogo } from 'src/views/components'
import { footerContainer } from 'src/models'
import { Row, Col } from 'react-bootstrap'
import { ApiContent, getDeviceType, IS_BROWSER } from 'src/utils'
import { pageNames } from 'src/routes/pathParams'
import nsLogoDark from 'src/images/ns_logo_mark_dark.svg'
import './styles.scss'

function PersonalFooter() {
  const [footerData, setFooterData] = useState({})
  const [footerLegalInfo, setFooterLegalInfo] = useState({})
  const isTabletorDesktop =
    getDeviceType() === 'tablet' || getDeviceType() === 'desktop' || false
  const isMobile = getDeviceType() === 'mobile' || false
  const context = useContext(ApiContent)
  const getFooterDetailLinks = async () => {
    const promises = await footerContainer.getFooterData({
      contextName: 'footerData',
      context: context,
      queryParams: {
        locale: 'en_US',
      },
    })
    setFooterLegalInfo(promises)
  }
  useEffect(() => {
    /**
     * @note
     * Update Cart quantity on Page load
     * Member for PersonalHeader
     */
    let fDataAsString = sessionStorage.getItem('footerData') || ''
    let userDataAsString = sessionStorage.getItem('storefront') || ''

    const footerInfo = {}

    try {
      if (fDataAsString) {
        fDataAsString = JSON.parse(fDataAsString)

        footerInfo.contactInfo = fDataAsString?.storefront?.contactInfoTitle
        footerInfo.privacyPolicyLabel =
          fDataAsString?.storefront?.detailsLinks?.[0]?.name
        footerInfo.termsAndConditionsLabel =
          fDataAsString?.storefront?.detailsLinks?.[1]?.name
        footerInfo.poweredByLabel = fDataAsString?.storefront?.poweredByLabel
        footerInfo.facebookLabel =
          fDataAsString?.socialMediaList[0]?.socialIconUrl
        footerInfo.twitterLabel =
          fDataAsString?.socialMediaList[1]?.socialIconUrl
        footerInfo.pinterestLabel =
          fDataAsString?.socialMediaList[2]?.socialIconUrl
      }

      if (userDataAsString) {
        userDataAsString = JSON.parse(userDataAsString)

        footerInfo.userName = userDataAsString?.displayName
        footerInfo.userEmail = userDataAsString?.email
        footerInfo.userPhone = userDataAsString?.phone
        footerInfo.userPhoto = userDataAsString?.profilePhoto || nsLogoDark
        footerInfo.socialAccounts = userDataAsString?.socialAccounts || {}
      }
    } catch (e) {
      console.error('JSON.parse may be an error >>> PersonalFooter', e)
    }
    setFooterData({ ...footerInfo })
    if (context?.ssrData?.footerData) {
      setFooterLegalInfo(context?.ssrData?.footerData)
    } else {
      getFooterDetailLinks()
    }
  }, [])

  const privacyTermsFooterLink = name => {
    if (typeof window !== 'undefined') {
      footerLegalInfo?.detailsLinks?.filter(data => {
        if (data?.name === name)
          window.open(
            data?.href?.includes('https://')
              ? `${data?.href}`
              : `https://www.nuskin.com${data?.href}`
          )
      })
    }
  }
  const socialMediaList = () => {
    return (
      <div className="social-media-links d-flex">
        {!isEmpty(footerData?.socialAccounts) &&
          footerData?.socialAccounts?.map((e, index) => {
            return (
              <div className="s-media-link" key={index}>
                <a
                  href={
                    e?.url.includes('https://') ? e?.url : `https://${e?.url}`
                  }
                  title={e?.name}
                  target="_blank"
                  rel="noopener noreferrer">
                  <img
                    src={`https://www.google.com/s2/favicons?domain=${e?.url}&sz=24`}
                    alt={`${e?.name} icon`}
                    width="24"
                    height="24"
                  />
                </a>
              </div>
            )
          })}
      </div>
    )
  }

  const renderUserDetails = () => {
    return (
      <div className="footer-usr-detail">
        <div className="user-name">{footerData.userName}</div>
        <div className="user-email">{footerData.userEmail}</div>
        <div className="user-phone">{footerData.userPhone}</div>
        {!isEmpty(footerData?.socialAccounts) && socialMediaList()}
      </div>
    )
  }
  const footerLogoData = () => {
    return (
      <div className="power-nuskin">
        <div className="power-by-txt">{footerData.poweredByLabel}</div>
        <div className="footer-nuskin-logo">
          <HeaderLogo />
        </div>
      </div>
    )
  }

  const isKlarnaCheckoutPage =
    IS_BROWSER && window?.location?.pathname?.includes(pageNames.klarnaCheckout)

  if (isKlarnaCheckoutPage) {
    return <></>
  }

  return (
    <>
      <div className="personalFooter">
        <div className="personalFooter-contgainer">
          <div className="contact-info-txt">{footerData.contactInfo}</div>
          <div className="footer-user-info d-flex">
            <div className="user-logo-info d-flex">
              <img
                src={footerData.userPhoto}
                className="personal-offer-footer-logo user-logo"
                alt="Avatar"
              />
              {renderUserDetails()}
            </div>
            {isTabletorDesktop && footerLogoData()}
          </div>
          {isMobile && footerLogoData()}
        </div>
        <div className="privacy-policy-service">
          <Link
            className="privacy-policy"
            onClick={() => privacyTermsFooterLink('Privacy')}
            rel="noopener noreferrer">
            {footerData.privacyPolicyLabel}
          </Link>
          <div className="divider">|</div>
          <Link
            className="privacy-policy"
            onClick={() => privacyTermsFooterLink('Terms of Use')}
            rel="noopener noreferrer">
            {footerData.termsAndConditionsLabel}
          </Link>
        </div>
      </div>
    </>
  )
}

export { PersonalFooter }
export default PersonalFooter
